// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"7fe29fd2","271":"edc0615d"}[chunkId] + ".css";
};